import type { Attachment } from '../api/types';
import { useCallback, useReducer, type SetStateAction } from 'react';
// Memory only: never persist private message bodies into WebView localStorage.
export const drafts = new Map<string, {message:string;attachments:Attachment[]}>();
export const clearDrafts = () => drafts.clear();
export function useDraft(key:string) {
  const [,refresh] = useReducer(value=>value+1,0);
  const draft=drafts.get(key)||{message:'',attachments:[]};
  const setMessage=useCallback((value:SetStateAction<string>)=>{
    const current=drafts.get(key)||{message:'',attachments:[]};
    drafts.set(key,{...current,message:typeof value==='function'?value(current.message):value});refresh();
  },[key]);
  const setAttachments=useCallback((value:SetStateAction<Attachment[]>)=>{
    const current=drafts.get(key)||{message:'',attachments:[]};
    drafts.set(key,{...current,attachments:typeof value==='function'?value(current.attachments):value});refresh();
  },[key]);
  return {...draft,setMessage,setAttachments};
}
